"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledListWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const empty_wrapper_1 = require("../empty-wrapper");
const StyledListWrapper = (props) => {
    const { children, subheader, ...rest } = props;
    return ((0, jsx_runtime_1.jsx)(empty_wrapper_1.StyledEmptyWrapper, { ...rest, children: (0, jsx_runtime_1.jsx)(ui_kit_1.List, { subheader: subheader, children: children }) }));
};
exports.StyledListWrapper = StyledListWrapper;
//# sourceMappingURL=index.js.map